

import Vue from "vue";
import {StoreServiceInstance} from "@/services/storeService";

export default Vue.extend({
  props: ["lang"],
  data() {
    return {
      model: this.lang
    }
  },
  methods: {
    async onSave() {
      await StoreServiceInstance.setData('language', this.model);
      location.reload()
    },
  },

})
